import { Box, Typography } from '@mui/material';
import type {
  ColumnId,
  FilterFieldConfig,
} from '../../../components/CatalogTable';
import { CatalogTable } from '../../../components/CatalogTable';
import { StudioPage } from '../../../page-templates/StudioPage';
import * as styles from './Catalog.styles';

// ─── Column Configuration ───────────────────────────────────────────────────────
// Only show these columns on the public Catalog page.
// The admin CatalogSection retains all columns independently.

const CATALOG_COLUMNS: ColumnId[] = [
  'artwork',
  'artist',
  'title',
  'release',
  'release_year',
  'genre',
  'explicitness',
  'bpm',
];

// ─── Filter Configuration ───────────────────────────────────────────────────────
// Filters are limited to the columns we're actually showing.

const CATALOG_FILTERS: FilterFieldConfig[] = [
  // Row 1: Text search fields
  {
    key: 'artistNameContains',
    label: 'Artist',
    type: 'text',
    group: 'text-search',
  },
  {
    key: 'titleContains',
    label: 'Title',
    type: 'text',
    group: 'text-search',
  },
  {
    key: 'releaseNameContains',
    label: 'Release',
    type: 'text',
    group: 'text-search',
  },
  // Row 2: Genre & Explicitness
  {
    key: 'genreContains',
    label: 'Genre',
    type: 'text',
    group: 'genre-explicit',
  },
  {
    key: 'explicitnessIs',
    label: 'Explicitness',
    type: 'select',
    group: 'genre-explicit',
    options: [
      { value: 'Explicit', label: 'Explicit' },
      { value: 'NotExplicit', label: 'Clean' },
      { value: 'ExplicitContentEdited', label: 'Censored' },
    ],
  },
  // Row 3: Release Year & BPM ranges
  {
    key: 'releaseYearGreaterThan',
    label: 'Release Year (from)',
    type: 'number',
    group: 'year-range',
  },
  {
    key: 'releaseYearLessThan',
    label: 'Release Year (to)',
    type: 'number',
    group: 'year-range',
  },
  {
    key: 'bpmGreaterThan',
    label: 'BPM (from)',
    type: 'number',
    group: 'bpm-range',
  },
  {
    key: 'bpmLessThan',
    label: 'BPM (to)',
    type: 'number',
    group: 'bpm-range',
  },
];

// ─── Component ──────────────────────────────────────────────────────────────────

export const Catalog = () => {
  return (
    <StudioPage>
      <Box sx={styles.pageContainer}>
        <Box sx={styles.headerSection}>
          <Typography variant="h4" sx={styles.pageTitle}>
            Catalog
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Browse and explore the full music catalog
          </Typography>
        </Box>

        <CatalogTable
          columns={CATALOG_COLUMNS}
          searchPlaceholder="Search by title, artist, release name, or ISRC..."
          enableTrackDetailNavigation={false}
          showFilters={true}
          filterFields={CATALOG_FILTERS}
        />
      </Box>
    </StudioPage>
  );
};
